export default {
  bot: 'Bot',
  attendents: 'Atendente',
  teams: 'Fila',
  tags: 'Tag',
  closedTickets: 'Tickets finalizados',
  averageFirstResponseTime: 'Tempo médio da 1° resposta',
  averageWaitTime: 'Tempo médio de espera',
  averageResponseTime: 'Tempo médio de resposta',
  averageAttendanceTime: 'Tempo médio de atendimento',
};
